// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"less-than-or-equal"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19 3L5 8.5L19 14","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M4 20H20","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LessThanOrEqualIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'less-than-or-equal',
    ref,
    icon: element,
  },
));

LessThanOrEqualIcon.displayName = 'LessThanOrEqualIcon';

export default LessThanOrEqualIcon;
